// Dependencies
import React, { Component } from 'react';

// Primereact imports
import { Chip } from 'primereact/chip';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';

// Styling
import './ballot-data.scss';

// Multi lang
import { getLanguage, withTranslation } from 'react-multi-lang';

// Utils
import { DOC_TYPE_COMP_CPE, DOC_TYPE_COMP_REGISTRATION_EU, DOC_TYPE_COMP_REGISTRATION_NON_EU, DOC_TYPE_PROFESSIONAL_HONOR, NO_OPTION, YES_OPTION } from '../../../common/constants';
import { EU_WITHOUT_PT_LIST, NON_EU_LIST } from '../../../common/lists/countries';
import { getCpeBallotList } from '../../../common/lists/ballot';
import { formatBallotDataFormValues } from '../../../common/formatters/ballot';
import { convertBase64ToArrayBuffer, downloadFile } from '../../../common/utils/download-utils';
import { getRegistrationDoc } from '../../../common/utils/registration-utils';
import { getYesNoDropdownList } from '../../../common/utils/form-data-utils';

// Redux
import { connect } from 'react-redux';
import DocumentService from '../../../redux/services/document';

class BallotDataComponent extends Component {

    constructor(props) {
        super(props);
        this._toast = React.createRef();
        this.state = {
            associate: null,
            readOnlyMode: true
        };
    }

    componentDidMount() {
        let associate = this.props.associate;

        this.setState({
            associate: formatBallotDataFormValues(associate, this.props.language)
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.language !== prevProps.language) {
            let associate = this.props.associate;

            this.setState({
                associate: formatBallotDataFormValues(associate, this.props.language)
            });
        }
    }

    downloadDocument(documentRef) {
        DocumentService.downloadDocument(documentRef)
          .then((response) => {
                var blob = new Blob([convertBase64ToArrayBuffer(response.fileContent)], { type: response.contentType });
                downloadFile(URL.createObjectURL(blob), response.filename);
          })
          .catch(error => {
              this._toast.current.show({ severity: 'error', detail: this.props.t("profile.messages.error"), life: 3000 });
          });
    }

  render() {
    let compCpe = getRegistrationDoc(this.props.registrationDocs, DOC_TYPE_COMP_CPE);
    let compRegistrationEuDoc = getRegistrationDoc(this.props.registrationDocs, DOC_TYPE_COMP_REGISTRATION_EU);
    let compRegistrationNonEuDoc = getRegistrationDoc(this.props.registrationDocs, DOC_TYPE_COMP_REGISTRATION_NON_EU);
    let honorProof = getRegistrationDoc(this.props.registrationDocs, DOC_TYPE_PROFESSIONAL_HONOR);

    return (
        this.state.associate !== null && this.state.associate.acssData !== null ? 
            <div className='grid mgb-80'>
                <div className='col-12'>
                    <div className="card p-fluid mgt-20">
                        <div className='grid'>
                            <div className='col-12 t-align-left'>
                                <label htmlFor="previousRegistration">{this.props.t("profile.areas.ballot.previous-registration")} <span className="invalid-message">*</span></label>
                                <Dropdown id="previousRegistration" value={this.state.associate.acssData.previousRegistration} disabled={this.state.readOnlyMode} options={getYesNoDropdownList(getLanguage())} optionLabel="name"></Dropdown>
                            </div>
                            {
                                this.state.associate.acssData.previousRegistration.code === YES_OPTION.code ? 
                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                        <label htmlFor="acssBallot">{this.props.t("profile.areas.ballot.has-acss-ballot")} <span className="invalid-message">*</span></label>
                                        <Dropdown id="acssBallot" value={this.state.associate.acssData.acssBallot} disabled={this.state.readOnlyMode} options={getYesNoDropdownList(getLanguage())} optionLabel="name"></Dropdown>
                                    </div>
                                : null
                            }
                            {
                                this.state.associate.acssData.previousRegistration.code === YES_OPTION.code && this.state.associate.acssData.acssBallot.code === YES_OPTION.code ? 
                                    <div className='col-1 t-align-right mgt-25'>
                                        <span>C-</span>
                                    </div>
                                    : null
                            }
                            {
                                this.state.associate.acssData.previousRegistration.code === YES_OPTION.code && this.state.associate.acssData.acssBallot.code === YES_OPTION.code ? 
                                    <div className='col-11 md:col-11 lg:col-5 t-align-left'>
                                        <label htmlFor="acssNumber">{this.props.t("profile.areas.ballot.ballot-number")} <span className="invalid-message">*</span></label>
                                        <InputText id="acssNumber" value={this.state.associate.acssData.acssBallotNumber} disabled={this.state.readOnlyMode} type="text" />
                                    </div>
                                    : null
                            }
                            {
                                this.state.associate.acssData.previousRegistration.code === YES_OPTION.code && this.state.associate.acssData.acssBallot.code === NO_OPTION.code ? 
                                    <div className='col-12 t-align-left'>
                                        <label htmlFor="hasBallotEuEftaCountry">{this.props.t("profile.areas.ballot.has-eu-efta-ballot")} <span className="invalid-message">*</span></label>
                                        <Dropdown id="hasBallotEuEftaCountry" value={this.state.associate.acssData.ballotCountryEuEfta} disabled={this.state.readOnlyMode} options={getYesNoDropdownList(getLanguage())} optionLabel="name"></Dropdown>
                                    </div>
                                    : null
                            }
                            {
                                this.state.associate.acssData.previousRegistration.code === YES_OPTION.code && 
                                this.state.associate.acssData.acssBallot.code === NO_OPTION.code &&
                                this.state.associate.acssData.ballotCountryEuEfta.code === YES_OPTION.code ? 
                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                        <label htmlFor="ballotEuCountry">{this.props.t("profile.areas.ballot.eu-efta-country")} <span className="invalid-message">*</span></label>
                                        <Dropdown id="ballotEuCountry" value={this.state.associate.acssData.ballotCountry} disabled={this.state.readOnlyMode} options={EU_WITHOUT_PT_LIST} optionLabel="name"></Dropdown>
                                    </div>
                                    : null
                            }
                            {
                                this.state.associate.acssData.previousRegistration.code === YES_OPTION.code && 
                                this.state.associate.acssData.acssBallot.code === NO_OPTION.code &&
                                this.state.associate.acssData.ballotCountryEuEfta.code === YES_OPTION.code ? 
                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                        <label htmlFor="hasCpeBallot">{this.props.t("profile.areas.ballot.has-cpe-ballot")} <span className="invalid-message">*</span></label>
                                        <Dropdown id="hasCpeBallot" value={this.state.associate.acssData.cpeBallot} disabled={this.state.readOnlyMode} options={getCpeBallotList(getLanguage())} optionLabel="name"></Dropdown>
                                    </div>
                                    : null
                            }
                            {
                                this.state.associate.acssData.previousRegistration.code === YES_OPTION.code && 
                                this.state.associate.acssData.acssBallot.code === NO_OPTION.code &&
                                this.state.associate.acssData.ballotCountryEuEfta.code === YES_OPTION.code && 
                                this.state.associate.acssData.cpeBallot.code === YES_OPTION.code ? 
                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                        <label htmlFor="cpeEntity">{this.props.t("profile.areas.ballot.cpe-entity")} <span className="invalid-message">*</span></label>
                                        <InputText id="cpeEntity" value={this.state.associate.acssData.cpeBallotEntity} disabled={this.state.readOnlyMode} type="text" />
                                    </div>
                                    : null
                            }
                            {
                                this.state.associate.acssData.previousRegistration.code === YES_OPTION.code && 
                                this.state.associate.acssData.acssBallot.code === NO_OPTION.code &&
                                this.state.associate.acssData.ballotCountryEuEfta.code === YES_OPTION.code && 
                                this.state.associate.acssData.cpeBallot.code === YES_OPTION.code ? 
                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                        <label htmlFor="processNumber">{this.props.t("profile.areas.ballot.process-num")} <span className="invalid-message">*</span></label>
                                        <InputText id="processNumber" value={this.state.associate.acssData.cpeBallotNumber} disabled={this.state.readOnlyMode} type="text" />
                                    </div>
                                    : null
                            }
                            {
                                this.state.associate.acssData.previousRegistration.code === YES_OPTION.code && 
                                this.state.associate.acssData.acssBallot.code === NO_OPTION.code &&
                                this.state.associate.acssData.ballotCountryEuEfta.code === NO_OPTION.code ? 
                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                        <label htmlFor="ballotCountry">{this.props.t("profile.areas.ballot.non-eu-efta-country")} <span className="invalid-message">*</span></label>
                                        <Dropdown id="ballotCountry" value={this.state.associate.acssData.ballotCountry} disabled={this.state.readOnlyMode} options={NON_EU_LIST} optionLabel="name"></Dropdown>
                                    </div>
                                    : null
                            }
                            {
                                this.state.associate.acssData.previousRegistration.code === YES_OPTION.code && 
                                this.state.associate.acssData.acssBallot.code === NO_OPTION.code &&
                                this.state.associate.acssData.ballotCountryEuEfta.code === NO_OPTION.code ? 
                                    <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                        <label htmlFor="entity">{this.props.t("profile.areas.ballot.entity")} <span className="invalid-message">*</span></label>
                                        <InputText id="entity" value={this.state.associate.acssData.cpeBallotEntity} disabled={this.state.readOnlyMode} type="text" />
                                    </div>
                                    : null
                            }
                            {
                                this.props.associate.acssData.acssBallot === false || this.props.associate.acssData.acssBallotNumber === "" ?
                                    <div className='col-12'><hr/></div>
                                    : null
                            }
                            <div className='col-12 t-align-left'>
                                {
                                    (this.props.associate.acssData.acssBallot === false || this.props.associate.acssData.acssBallotNumber === "") && this.props.associate.acssData.cpeBallot === true && compCpe !== null ?                                    
                                        <span onClick={() => this.downloadDocument(compCpe.nodeRef)}>
                                            <Chip title={this.props.t("general.download")} style={{color: "#FFFFFF", background:"#0073aa", cursor: 'pointer'}} label={this.props.t("profile.areas.professional.documents.comp-professional")} icon="pi pi-download" className="mr-2 mb-2" />
                                        </span>
                                        : null
                                }
                                {
                                    (this.props.associate.acssData.acssBallot === false || this.props.associate.acssData.acssBallotNumber === "") && this.props.associate.acssData.cpeBallot === false && this.props.associate.acssData.ballotCountryEuEfta === true && compRegistrationEuDoc !== null ?
                                        <span className='mgl-10' onClick={() => this.downloadDocument(compRegistrationEuDoc.nodeRef)}>
                                            <Chip title={this.props.t("general.download")} style={{color: "#FFFFFF", background:"#0073aa", cursor: 'pointer'}} label={this.props.t("profile.areas.professional.documents.good-standing")} icon="pi pi-download" className="mr-2 mb-2" />
                                        </span>
                                        : null
                                }
                                {
                                    (this.props.associate.acssData.acssBallot === false || this.props.associate.acssData.acssBallotNumber === "") && this.props.associate.acssData.cpeBallot === false && this.props.associate.acssData.ballotCountryEuEfta === false && compRegistrationNonEuDoc !== null ?
                                        <span className='mgl-10' onClick={() => this.downloadDocument(compRegistrationNonEuDoc.nodeRef)}>
                                            <Chip title={this.props.t("general.download")} style={{color: "#FFFFFF", background:"#0073aa", cursor: 'pointer'}} label={this.props.t("profile.areas.professional.documents.good-standing")} icon="pi pi-download" className="mr-2 mb-2" />
                                        </span>
                                        : null
                                }
                                {
                                    (this.props.associate.acssData.acssBallot === false || this.props.associate.acssData.acssBallotNumber === "") && this.props.associate.acssData.cpeBallot === false && this.props.associate.acssData.ballotCountryEuEfta === false && honorProof !== null ?
                                        <span className='mgl-10' onClick={() => this.downloadDocument(honorProof.nodeRef)}>
                                            <Chip title={this.props.t("general.download")} style={{color: "#FFFFFF", background:"#0073aa", cursor: 'pointer'}} label={this.props.t("profile.areas.professional.documents.good-standing")} icon="pi pi-download" className="mr-2 mb-2" />
                                        </span>
                                        : null
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <Toast position='bottom-left' ref={this._toast} />
            </div>
            : null
    );
  }
}

const mapStateToProps = (state) => {
    return {
        associate: state.profile.associate,
        registrationDocs: state.profile.registrationDocs,
        language: state.profile.language
    } 
};
  
const mapDispatchToProps = (dispatch) => {
    return {

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(BallotDataComponent));